import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './FloatingBubbleModal.css'; // reutilizamos estilos
import { useSelector } from 'react-redux';
import moment from 'moment';
import { jwtDecode } from 'jwt-decode';




const FloatingVuelosModal = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isFormOpen, setIsFormOpen] = useState(false);
    const [vuelos, setVuelos] = useState([]);
    const [formData, setFormData] = useState({
      fechaVuelo: new Date().toISOString().split('T')[0],
      aerolinea: '',
      noVuelo: ''
    });
  
    const token = useSelector((state) => state.auth.token);
    const decoded = token ? jwtDecode(token) : {};
    const estacionUsuario = decoded.estacion?.trim().toUpperCase() || 'GDL';
  
    const aerolineasPorEstacion = {
        GDL: ["AM", "DL", "UA", "AA","AC"],
        PVR: ["AM", "UA", "F8", "F9", "DL", "CNT", "TA", "AC"],
        MTY: ["AA", "DL", "SW"],
        MEX: ["FFT", "FLE", "UA"],
        CUN: ["AM", "UA", "DL"],
      };
  
    const aerolineasDisponibles = aerolineasPorEstacion[estacionUsuario] || aerolineasPorEstacion.DEFAULT;
  
    const fetchVuelos = async () => {
      try {
        const response = await axios.get('https://orionadministracion.com/api/vuelos', {
          headers: { Authorization: `Bearer ${token}` }
        });
        setVuelos(response.data);
      } catch (error) {
        console.error('Error al obtener vuelos:', error);
      }
    };
  
    const eliminarVuelo = async (id) => {
      if (!window.confirm('¿Estás seguro de eliminar este vuelo?')) return;
      try {
        await axios.delete(`https://orionadministracion.com/api/vuelos/${id}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        fetchVuelos();
      } catch (error) {
        console.error('Error al eliminar vuelo:', error);
        alert('No se pudo eliminar el vuelo');
      }
    };
  
    useEffect(() => {
      if (isModalOpen) {
        fetchVuelos();
      }
    }, [isModalOpen]);
  
    const handleGuardarVuelo = async () => {
      const { fechaVuelo, aerolinea, noVuelo } = formData;
      if (!fechaVuelo || !aerolinea || !noVuelo) {
        alert('Todos los campos son requeridos');
        return;
      }
      try {
        await axios.post('https://orionadministracion.com/api/vuelos', formData, {
          headers: { Authorization: `Bearer ${token}` },
        });
        fetchVuelos();
        setIsFormOpen(false);
        setFormData({ ...formData, noVuelo: '' });
      } catch (error) {
        console.error('Error al guardar vuelo:', error);
        alert('Error al guardar vuelo');
      }
    };
  
    return (
      <div>
        {/* Burbuja flotante del avión */}
        <div
          className={`floating-bubble airplane ${isModalOpen ? 'bubble-active' : ''}`}
          onClick={() => setIsModalOpen(!isModalOpen)}
        >
          ✈️
        </div>
  
        {/* Modal */}
        {isModalOpen && (
          <div className="modal-overlay">
            <div className="modal modal-animate-in">
              <div className="modal-header">
                <h2>Vuelos Registrados</h2>
                <button className="close-button" onClick={() => setIsModalOpen(false)}>✖</button>
              </div>
              <button className="btn-submit" onClick={() => setIsFormOpen(true)}>Registrar Vuelo</button>
  
              {/* Formulario de vuelo */}
              {isFormOpen && (
                <div className="modal-body">
                  <label>Fecha:</label>
                  <input
                    type="date"
                    value={formData.fechaVuelo}
                    onChange={(e) => setFormData({ ...formData, fechaVuelo: e.target.value })}
                  />
  
                  <label>Aerolínea:</label>
                  <select
                    value={formData.aerolinea}
                    onChange={(e) => setFormData({ ...formData, aerolinea: e.target.value })}
                  >
                    <option value="">Selecciona una opción</option>
                    {aerolineasDisponibles.map((aero) => (
                      <option key={aero} value={aero}>{aero}</option>
                    ))}
                  </select>
  
                  <label>Número de Vuelo:</label>
                  <input
                    type="text"
                    value={formData.noVuelo}
                    onChange={(e) => setFormData({ ...formData, noVuelo: e.target.value })}
                  />
  
                  <button className="btn-submit" onClick={handleGuardarVuelo}>Guardar</button>
                </div>
              )}
  
              <div className="modal-body">
                <table className="bitacora-table">
                  <thead>
                    <tr>
                      <th>Fecha</th>
                      <th>Aerolínea</th>
                      <th>Vuelo</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {vuelos.map((vuelo) => (
                      <tr key={vuelo.idvuelo}>
                        <td>{moment(vuelo.fechaVuelo).format('YYYY-MM-DD')}</td>
                        <td>{vuelo.aerolinea}</td>
                        <td>{vuelo.noVuelo}</td>
                        <td>
                          <button onClick={() => eliminarVuelo(vuelo.idvuelo)} className="btn-close">🗑️</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };
export default FloatingVuelosModal;
